var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab center-block"},[_c('CreateSiteButton',{attrs:{"size":"large"}}),_c('el-button',{attrs:{"type":"primary","size":"large"},on:{"click":function($event){return _vm.$router.push('/user/projects')}}},[_c('i',{staticClass:"el-icon-edit-outline"}),_vm._v(" "+_vm._s(_vm.$t('tabs.start.openProject'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }